import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { CircularProgress, Container, Typography } from '@mui/material';

// APIs
import { getPractice } from '../../../api';

// Components
import { Button, LineItem } from '@lexcelon/react-util';

import { setError } from '../../../alerts';

//Constants
const red = '#d32f2f';

class Practice extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      practice: null
    };
  }

  componentDidMount() {
    this.retrievePractice();
  }

  retrievePractice = () => {
    // Retrieve the practice id from the url

    this.setState({ isLoading: true });
    getPractice().then(practice => {
      this.setState({ isLoading: false, practice });
    }).catch(error => {
      setError(error ?? 'Error: Unable to retrieve practice info. Please try again.');
      this.setState({ isLoading: false });
    });
  }

  render() {
    var isSuspended = this.state.practice?.getIsSuspended();
    return (
      <Container style={{ paddingTop: '20px' }}>

        <Typography variant='h1' style={{ textAlign: 'center', marginTop: '1em' }}>{this.state.practice?.getName()}</Typography>
        <Typography variant='h6' style={{ textAlign: 'center', marginBottom: '0.5em', color: isSuspended ? red : 'green' }}>{isSuspended ? 'SUSPENDED' : ('ACTIVE')}</Typography>

        {this.state.isLoading ? (
          <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <CircularProgress />
          </div>
        ) : (
          <>
            <Typography variant='h2' style={{ marginBottom: '0.5em' }}>Practice Info</Typography>
            <>
              <LineItem
                value={this.state.practice?.getIdentifier()}
                description='Identifier'
              />

              <LineItem
                value={this.state.practice?.getName()}
                description='Name'
              />

              <Button component={Link} to='/instruments'>View All Instruments</Button>
            </>

            <Typography variant='h2' style={{ marginBottom: '0.5em', marginTop: '1em' }}>Contact Info</Typography>
            <>
              <LineItem
                value={this.state.practice?.getContactName()}
                description='Contact Name'
              />

              <LineItem
                value={this.state.practice?.getContactEmail()}
                description='Contact Email'
              />

              <LineItem
                value={this.state.practice?.getContactPhoneNumber()}
                description='Contact Phone Number'
              />

            </>

            <Typography variant='h2' style={{ marginBottom: '0.5em', marginTop: '1em' }}>Practice Location</Typography>
            <>
              <LineItem
                value={this.state.practice?.getAddress()?.getFullAddress()}
                style={{ marginTop: '0' }}
                description='Address'
              />

              <LineItem
                value={this.state.practice?.getAddress()?.getTimeZone()}
                description='Timezone'
              />

            </>

          </>
        )}
      </Container>
    );
  }
}

export default Practice;
